import React from "react";
import "./pages/App.css";
function TestButton({ handele, setWait, set, children }) {
  const handleClick = () => {
    setWait(true);
    console.log("Some");
    if (handele) {
      handele();
    }
    setTimeout(myFunction, 60);
  };
  function myFunction() {
    setWait(false);
    set((current) => !current);
  }
  return (
    <button className="btn__test" onClick={handleClick}>
      {children}
    </button>
  );
}

export default TestButton;
